import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MembershipManagementService } from '../membership-management.service';
import { ToastNotificationService } from '../../../core/toast-notification.service';
import { UIBlockingService } from '../../../core/ui-blocking.service';
import { SignUpService } from '../../../sign-up/sign-up.service';
import { MemberUserManagementService } from '../../member-user-management/member-user-management.service';
import { DumbCompanyDetails } from '../DTOs/dumb-company';

@Component({
  selector: 'app-edit-company-directory-info-modal',
  templateUrl: './edit-company-directory-info-modal.component.html',
  encapsulation: ViewEncapsulation.None
})
export class EditCompanyDirectoryInfoModalComponent {
    company: DumbCompanyDetails;
    isCompanyLiaison: boolean = false;

    constructor(private activeModal: NgbActiveModal,
        private fb: FormBuilder,
        private membershipService: MembershipManagementService,
        private notificationService: ToastNotificationService,
        private blockUI: UIBlockingService) { }

    descriptionCtrl = new FormControl("description");
    directoryOptInCtrl = new FormControl("directoryOptIn", [Validators.required]);
    logo: File = null;
    maxImageSize = 500000000; // 500 MB
    imageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    websiteCtrl = new FormControl("website");

    manageCompanyDirectoryInfoForm: FormGroup = new FormGroup({
        description: this.descriptionCtrl,
        directoryOptIn: this.directoryOptInCtrl,
        website: this.websiteCtrl,
    });

    description() { return this.manageCompanyDirectoryInfoForm.get('description').value }
    directoryOptIn() { return this.manageCompanyDirectoryInfoForm.get('directoryOptIn').value }
    website() { return this.manageCompanyDirectoryInfoForm.get('website').value }

    ngOnInit() {
        this.isCompanyLiaison = this.company.liaison.contactId == localStorage.getItem("contactId");
        this.resetManageCompanyInfoForm();
    }

    private resetManageCompanyInfoForm(): void {
        this.manageCompanyDirectoryInfoForm.reset();
        this.manageCompanyDirectoryInfoForm.patchValue({
            description: this.company.description,
            directoryOptIn: this.company.isLiaisonOptedIn,
            website: this.company.website,
        });
        this.logo = null;
    }

    save() {
        for (var i in this.manageCompanyDirectoryInfoForm.controls) {
            this.manageCompanyDirectoryInfoForm.controls[i].markAsTouched();
        }
        if (!this.manageCompanyDirectoryInfoForm.valid) {
            return false;
        }
        if (this.logo != null) {
            return this.saveLogoAndDetails();
        }
        else {
            return this.saveCompanyDetails(null);
        }
    }

    saveLogoAndDetails() {
        this.uploadLogoFile()
            .subscribe({
                next: (data) => {
                    this.saveCompanyDetails(data);
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                }
            });
    }

    uploadLogoFile() {
        const uploadData = new FormData();
        uploadData.append('logo', this.logo, this.logo.name);
        return this.membershipService.uploadLogoFile(uploadData);
    }

    saveCompanyDetails(logoId) {
        this.company.description = this.description();
        this.company.newLogoId = logoId;
        this.company.isLiaisonOptedIn = this.directoryOptIn();
        this.company.website = this.website();

        this.blockUI.start();
        this.membershipService.UpdateCompanyDirectoryDetails(this.company)
            .subscribe({
                next: (data) => {
                    this.blockUI.stop();
                    this.activeModal.close(data);
                },
                error: (err) => {
                    console.log(err)
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
            });
        return true;
    }

    dismiss(): void {
        this.activeModal.dismiss();
    }

    updateLogoImage(e) {
        var files = e.target.files;
        if (!this.imageTypes.includes(files.item(0).type)) {
            this.notificationService.error("File is not a recognized image type.")
            e.target.value = null;
            return;
        }
        if (files.item(0).size > this.maxImageSize) {
            this.notificationService.error(files.item(0).name + " is larger than the maximum file size.");
            e.target.value = null;
            return;
        }

        this.logo = files[0];
    }
}
